// Reusable empty-state. Use when a list/page has loaded but has nothing
// to display — softer than an error, more guidance than silence.
//
//   <EmptyState
//     icon="inbox"
//     title="No items yet"
//     subtitle="Add your first item to get started."
//     action={<Button onClick={create}>Add item</Button>}
//   />

import React from 'react';

const EmptyState = ({ icon = 'inbox', title, subtitle, action }) => (
  <div className="text-center py-5">
    <div
      className="d-inline-flex align-items-center justify-content-center mb-3 rounded-circle"
      style={{
        width: 64,
        height: 64,
        background: 'var(--tp-surface-2)',
        color: 'var(--tp-muted)',
      }}
      aria-hidden="true"
    >
      <i className={`fa-solid fa-${icon} fa-lg`}></i>
    </div>
    {title && <h5 className="mb-1">{title}</h5>}
    {subtitle && <p className="text-body-secondary mb-3">{subtitle}</p>}
    {action}
  </div>
);

export default EmptyState;
